import { Component, Inject, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'mobile-quote-dialog',
    templateUrl: 'quote-dialog.component.html',
    styleUrls: ['./quote-dialog.component.css']
})
export class QuoteMobileDialog {

    refreshEmitter = new EventEmitter<string>();

    constructor(
        public dialogRef: MatDialogRef<QuoteMobileDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    onNoClick(): void {
        this.dialogRef.close();
    }

    quoteRefresh(evt) {
        this.refreshEmitter.emit(evt);
    }

}
